export default "/crvUSD-FRAX.b6ce6f9b7dd414470b338c32e84cb50e.png";